
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^((47|57|75)4|822)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
